import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, Loader2 } from "lucide-react";
import { loginTransport } from "@/Calls/callTransportAuth";

export default function TransportLoginPage() {
    const navigate = useNavigate();
    const [email, setEmail]       = useState("");
    const [password, setPassword] = useState("");
    const [error, setError]       = useState<string | null>(null);
    const [loading, setLoading]   = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await loginTransport(email, password);
            navigate("/transport/dashboard");
        } catch (err: any) {
            setError(err.response?.data?.message ?? "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex">
            <div
                className="hidden lg:flex flex-1 items-center justify-center bg-cover bg-center relative"
                style={{ backgroundImage: "url(/images/assets/global_transport_futuristic_1.png)" }}
            >
                <div className="absolute inset-0 bg-blue-900/60" />
                <div className="relative z-10 text-white text-center p-8">
                    <Truck className="h-16 w-16 mx-auto mb-4 opacity-90" />
                    <h1 className="text-4xl font-bold mb-2">Transport Portal</h1>
                    <p className="text-blue-200 text-lg">Manage shipments and deliveries</p>
                </div>
            </div>

            <div className="flex flex-1 items-center justify-center bg-background p-8">
                <div className="w-full max-w-sm">
                    <div className="flex items-center gap-3 mb-8">
                        <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center">
                            <Truck className="h-5 w-5 text-white" />
                        </div>
                        <div>
                            <h2 className="font-semibold text-lg">Transport Partner</h2>
                            <p className="text-muted-foreground text-sm">IDSCRM Partner Portal</p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Email</label>
                            <input
                                type="email" required
                                value={email} onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-background"
                                placeholder="company@example.com"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Password</label>
                            <input
                                type="password" required
                                value={password} onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-background"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <button
                            type="submit" disabled={loading}
                            className="w-full py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                        >
                            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
